import React from 'react';
import { ViewComponentProps, withView } from '../shared/viewcomponent';
import { SearchSection } from './searchsection';


export const ChangeSecondaryAddresseeComponent = withView((props: ViewComponentProps) => {
    let companyCode = props.getQueryParam("companyCode")
    let policyNumber = props.getQueryParam("policyNumber")
    let fromPage = props.getQueryParam('fromPage')

    return <>
        <SearchSection {...props} changeType={4} companyCode={companyCode} policyNumber={policyNumber} fromPage={fromPage} />
    </>

});
